// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "staticPC/css/" + chunkId + "." + {"16":"a1fc6ecb","109":"10224813","189":"8e9681a5","222":"8d3b25c1","319":"d0fccdbb","327":"c424db87","406":"487ed51e","420":"ae081546","454":"d2a82893","506":"1a9731a0","940":"f9678b41"}[chunkId] + ".css";
};